import { Loader2 } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";

export function LoadingScreen() {
  const { translate } = useTranslation();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center space-y-4">
        <Loader2 className="h-8 w-8 animate-spin text-primary mx-auto" />
        <p className="text-muted-foreground animate-pulse">{translate("common_loading")}</p>
      </div>
    </div>
  );
}
